<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<!-- <QueryCondition @query="query"  ref="queryCondition" /> -->

			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
	
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryConditionCount'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
		},
		data() {
			return {
				queryParams: {

				},
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '用户ID',
						width: 200,
						key: 'userId',
						align: 'center'
					},
					{
						title: '用户手机号',
						width: 200,
						key: 'userMobile',
						align: 'center'
					},
					{
						title: '企业名称',
						width: 200,
						key: 'company',
						align: 'center'
					},
					{
						title: '购买套餐',
						key: 'productName',
						align: 'center',
						width: 200,
					},
					{
						title: '支付费用',
						key: 'payAmount',
						align: 'center',
						width: 200,
					},
					{
						title: '会员结束时间',
						key: 'endTime',
						align: 'center',
						width: 200,
					},
					{
						title: '支付时间',
						key: 'payTime',
						align: 'center',
						width: 200,
					}
				]
			},
		},
		created() {
			this.getData();
		},
		methods: {

			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.payList(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
		}
	}
</script>